import axios from "axios"
import baseURL from "../configs/api"

export const post_Reservation = (data: any, userId: number) => {
    return axios({
        url: `${baseURL}reservation?userId=${userId}`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        withCredentials: true,
        data: data
    }).then(response => response.data);
}


export const post_ConfirmReservation = (data: any, userId: number, tenantId: string) => {
    return axios({
        url: `${baseURL}reservation/confirmReservation?userId=${userId}`,
        method: "POST",
        headers: {
            'X-Tenant-ID': tenantId,
            "Content-Type": "application/json"
        },
        withCredentials: true,
        data: data
    }).then(response => response.data);
}


export const send_Receipt = async (data: any, userId: number, tenantId: string) => {
    const response = await axios({
        url: `${baseURL}receiptAgreementEmail?userId=${userId}`,
        method: "POST",
        headers: {
            'X-Tenant-ID': tenantId,
            "Content-Type": "application/json"
        },
        withCredentials: true,
        data: data
    });
    return response.data;
}

export const send_RentalAgreement = async (data: any, userId: number, tenantId: string) => {
    const response = await axios({
        url: `${baseURL}rentalAgreementEmail?userId=${userId}`,
        method: "POST",
        headers: {
            'X-Tenant-ID': tenantId,
            "Content-Type": "application/json"
        },
        withCredentials: true,
        data: data
    });
    return response.data;
}

export const put_Reservation = (data: any, userId: number, tenantId: string) => {
    return axios({
        url: `${baseURL}reservation?userId=${userId}`,
        method: "PUT",
        headers: {
            'X-Tenant-ID': tenantId,
            "Content-Type": "application/json"
        },
        withCredentials: true,
        data: data
    }).then(response => response.data);
}

export const updateReturnLocationOfReservation = (reservationId: number, returnLocationId: number, userId: number) => {
    return axios({
        url: `${baseURL}reservation/UpdateReturnLocationOfReservation/${reservationId},${returnLocationId},${userId}`,
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        withCredentials: true,
    }).then(response => response.data);
}

export const getReservations = (tenantId: string) => {
    return getFetch("reservation", tenantId);
}

export const getReservation = (primaryKey: string, tenantId: string) => {
    return getFetch(`reservation/${primaryKey}`, tenantId);
}


const getFetch = (url: string, tenantId: string, params = {}) => {
    return axios({
        url: baseURL + url,
        method: "GET",
        headers: {
            'X-Tenant-ID': tenantId,
            "Content-Type": "application/json"
        },
        params: params
    }).then(response => response.data);
}